import { Grid, useToken } from '@chakra-ui/react'

import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { useInsuranceParams } from '../../../context/InsuranceParamsProvider'
import { useWizzardHeader } from '../../../context/WizzardHeaderContext'
import { useGetHistory } from '../../../hooks/useInsuranceParams'
import { HistoryEntry } from './HistoryEntry'

export const WizzardHeaderHistory = () => {
  const { app } = useApp()
  const { isScrolled } = useWizzardHeader()
  const { insuranceParamsId } = useInsuranceParams()
  const { data } = useGetHistory(insuranceParamsId!, { retry: false, enabled: app !== Apps.publicPoleas })
  const items = data?.data ?? []

  const [scrollbarTrackColor, scrollbarThumbColor] = useToken('colors', [
    'wizzard-header-history-scrollbar-track-color',
    'wizzard-header-history-scrollbar-thumb-color',
  ])

  return (
    <Grid
      sx={{
        gap: {
          base: 0,
          lg: 1,
        },
        overflow: 'auto',
        maxH: '120px',
        scrollbarColor: `${scrollbarTrackColor} ${scrollbarThumbColor}`,
        scrollbarWidth: 'thin',
        paddingRight: 3,
      }}
    >
      {items.length > 0 &&
        !isScrolled &&
        items
          .sort((a, b) => {
            return new Date(a.dateCreated).getTime() - new Date(b.dateCreated).getTime()
          })
          .map((item, index) => (
            <HistoryEntry
              key={index}
              isLast={index === items.length - 1}
              {...item}
            />
          ))}
    </Grid>
  )
}
